import React from "react";
import ReactTextTransition from "react-text-transition";

const JumpNumberTransition = (props) => {
  return (
    <span>
    {`${props.value}`.split("").map((n, i) => (
      <ReactTextTransition
        key={i}
        text={n}
        delay={i * 100}
        overflow
        inline
      />
    ))}
    </span>
  );
}

export default JumpNumberTransition;